import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  IAddressViewModel,
  ICourtViewModel,
  IDemandViewModel,
  IDemandProposalViewModal,
  ISolicitationViewModel,
} from 'viewModels';
import { IAttachment } from '../components/Attachment';
import { ColorEvent, TypeEvent } from '../pages/Schedule/Event';
import { useAuth } from './auth';

type EventsProviderProps = {
  children: ReactNode;
};

export type IEvent = {
  id: string;
  date: Date;
  type: TypeEvent;
  color: ColorEvent;
  title?: string;
  description?: string;
  conference?: string;
  attachments?: IAttachment[];
  place?: IAddressViewModel;
  value?: string;
  note?: string;
  annotation?: string;
  status?: number;
  court?: ICourtViewModel;
  solicitation?: ISolicitationViewModel;
  demand?: IDemandViewModel;
  demandProposal?: IDemandProposalViewModal;
};

type EventsContextProps = {
  events: IEvent[];
  setEvents: Dispatch<SetStateAction<IEvent[]>>;
};

const EventsContext = createContext({} as EventsContextProps);

export function EventsProvider({ children }: EventsProviderProps) {
  const { tokenIsValid } = useAuth();

  const [events, setEvents] = useState<IEvent[]>([]);

  useEffect(() => {
    if (!tokenIsValid) setEvents([]);
  }, [tokenIsValid]);
  const contextValues = useMemo(() => ({ events, setEvents }), [events]);

  return <EventsContext.Provider value={contextValues}>{children}</EventsContext.Provider>;
}

export const useEvents = () => useContext(EventsContext);
